(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsDisabled = this.getAttribute('data-sticky-type') === 'none';
      this.headerBounds = {};
      this.announcementBar = null;
      this.announcementBarResizeObserver = null;
      this.mobileSearchMediaQuery = window.matchMedia('(max-width: 989px)');
      this.mobileSearchHasCompacted = false;
      this.mobileSearchCollapseTimer = null;
      this.onSectionLoadHandler = this.syncAnnouncementBar.bind(this);

      this.syncAnnouncementBar();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.onMobileSearchBreakpointChange = this.syncMobileSearchCompactState.bind(this);
      this.mobileSearchMediaQuery.addEventListener('change', this.onMobileSearchBreakpointChange);
      document.addEventListener('shopify:section:load', this.onSectionLoadHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (this.headerIsDisabled) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.syncMobileSearchCompactState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${this.announcementBar?.offsetHeight || 0}px`,
      );
    }

    syncAnnouncementBar() {
      const announcementBar = document.querySelector('.announcement-bar-section');

      if (announcementBar !== this.announcementBar) {
        this.announcementBarResizeObserver?.disconnect();
        this.announcementBar = announcementBar;

        if (this.announcementBar && 'ResizeObserver' in window) {
          this.announcementBarResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
          this.announcementBarResizeObserver.observe(this.announcementBar);
        }
      }

      this.setHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileSearchMediaQuery.removeEventListener('change', this.onMobileSearchBreakpointChange);
      document.removeEventListener('shopify:section:load', this.onSectionLoadHandler);
      this.announcementBarResizeObserver?.disconnect();
      window.clearTimeout(this.mobileSearchCollapseTimer);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.onScroll();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const hasScrolledPastHeader = scrollTop > this.headerBounds.bottom;
      const shouldCompactMobileSearch =
        this.mobileSearchMediaQuery.matches &&
        !this.mobileSearchHasCompacted &&
        scrollTop > 8;

      if (hasScrolledPastHeader) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      }

      if (shouldCompactMobileSearch) this.mobileSearchHasCompacted = true;

      this.syncMobileSearchCompactState();

      if (this.headerIsDisabled) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    syncMobileSearchCompactState() {
      const shouldCompact = this.mobileSearchMediaQuery.matches && this.mobileSearchHasCompacted;
      if (this.header.classList.contains('tg-header-mobile-search-compact') === shouldCompact) return;

      window.clearTimeout(this.mobileSearchCollapseTimer);
      this.header.classList.toggle('tg-header-mobile-search-compact', shouldCompact);

      if (shouldCompact) {
        const collapseDelay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
        this.mobileSearchCollapseTimer = window.setTimeout(() => {
          this.header.classList.add('tg-header-mobile-search-collapsed');
          this.setHeaderHeight();
        }, collapseDelay);
      } else {
        this.header.classList.remove('tg-header-mobile-search-collapsed');
      }

      requestAnimationFrame(() => this.setHeaderHeight());
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
